module.exports = __webpack_public_path__ + "img/arrow.25e5338e.svg";